var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallLeftArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.47619 0L0 6.5L6.47619 13L8 11.4706L3.04762 6.5L8 1.52941L6.47619 0Z",
    fill: "#0F1011"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallLeftArrowIcon);
export default __webpack_public_path__ + "static/media/small-left-arrow-icon.d0a458e467b6c3dac4719123b32f33bf.svg";
export { ForwardRef as ReactComponent };